import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import ExpMinWasSetForEachStackItemValidator from 'components/organisms/mlb-hitter-stacking/validators/exp-min-was-set-for-each-stack-item-validator';
import TeamWasSetForEachStackItemValidator from 'components/organisms/mlb-hitter-stacking/validators/team-was-set-for-each-stack-item-validator';
import TeamNotRepeatedInOneGroupValidator from 'components/organisms/mlb-hitter-stacking/validators/team-not-repeasted-in-one-group-validator';
import PlayersQuantityValidForEachStackItemValidator from 'components/organisms/mlb-hitter-stacking/validators/players-quantity-valid-for-each-stack-item-validator';
import MaxHittersInLineupValidator from 'components/organisms/mlb-hitter-stacking/validators/max-hitters-in-lineup-validator';
import ExpSumNotExceededForEachStackGroupValidator from 'components/organisms/mlb-hitter-stacking/validators/exp-sum-not-exceeded-for-each-stack-group-validator';
import BaseValidator from 'services/validations/base-validator';

class LegacyControlledHitterStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            stacks: {hitters: legacyControlledHitterStacking},
            playersData: {players},
            sportConfig,
        } = Action.getState();

        const validator = new BaseValidator();

        if (!legacyControlledHitterStacking.isEnabled()) {
            return validator;
        }

        const expMinWasSetForEachStackItemValidator = new ExpMinWasSetForEachStackItemValidator();
        expMinWasSetForEachStackItemValidator.setDependencies({legacyControlledHitterStacking});

        const teamWasSetForEachStackItemValidator = new TeamWasSetForEachStackItemValidator();
        teamWasSetForEachStackItemValidator.setDependencies({legacyControlledHitterStacking});

        const teamNotRepeatedInOneGroupValidator = new TeamNotRepeatedInOneGroupValidator();
        teamNotRepeatedInOneGroupValidator.setDependencies({legacyControlledHitterStacking});

        const playersQuantityValidForEachStackItemValidator = new PlayersQuantityValidForEachStackItemValidator();
        playersQuantityValidForEachStackItemValidator.setDependencies({legacyControlledHitterStacking, players});

        const maxHittersInLineupValidator = new MaxHittersInLineupValidator();
        maxHittersInLineupValidator.setDependencies({legacyControlledHitterStacking, sportConfig});

        const expSumNotExceededForEachStackGroupValidator = new ExpSumNotExceededForEachStackGroupValidator();
        expSumNotExceededForEachStackGroupValidator.setDependencies({legacyControlledHitterStacking});

        validator.addSubValidators([
            expMinWasSetForEachStackItemValidator,
            teamWasSetForEachStackItemValidator,
            teamNotRepeatedInOneGroupValidator,
            playersQuantityValidForEachStackItemValidator,
            maxHittersInLineupValidator,
            expSumNotExceededForEachStackGroupValidator,
        ]);

        return validator;
    }
}

export {LegacyControlledHitterStackingValidatorBuilder};
